import { atom } from "recoil";

type changeFactorStepFlagsAtom = {
  singleChangeStep: Array<number>;
};

const changeFactorStepFlagsAtom = atom({
  key: "@change_factor_steps_flags_atom",
  default: {
    singleChangeStep: [],
    multiChangeStep: false,
    countEditingMode: false,
  },
});

export default changeFactorStepFlagsAtom;
